import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Aegis AI Admin Panel — Firebase project: aegis-vision-464501
// App ID: 1:749148883861:web:fd38a8bb419d707cd3049c
const firebaseConfig = {
  apiKey: "AIzaSyDTa69g8lGyGxe5gk8lzYlnUzb9k0OGcVU",
  authDomain: "aegis-vision-464501.firebaseapp.com",
  projectId: "aegis-vision-464501",
  storageBucket: "aegis-vision-464501.firebasestorage.app",
  messagingSenderId: "749148883861",
  appId: "1:749148883861:web:fd38a8bb419d707cd3049c",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// Request the user's email so we can gate on admin role
googleProvider.addScope('email');

if (import.meta.env.DEV && import.meta.env.VITE_USE_FIRESTORE_EMULATOR === 'true') {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
  } catch {
    // already connected
  }
}

export default app;
